const matching = {
  title: "Движок сопоставления",
  description: "AI-сопоставление сущностей — работники, проекты, подрядчики и лиды",
  sourceEntity: "Исходная сущность",
  targetType: "Целевой тип",
  findMatches: "Найти совпадения",
  noMatches: "Совпадений не найдено",
  score: "Оценка",
  semanticScore: "Семантическая оценка",
  fieldScore: "Оценка полей",
  recencyScore: "Оценка актуальности",
  breakdown: "Детализация",
  cached: "Из кеша",
  refresh: "Обновить",
  refreshAll: "Обновить все",
  topMatches: "Лучшие совпадения",
  loadingMatches: "Поиск совпадений...",
  selectSource: "Выберите исходную сущность",
  selectType: "Выберите тип сущности",
  matchProfile: "Профиль совпадения",
  editProfile: "Редактировать профиль",
  saveProfile: "Сохранить",
  highMatch: "Высокое совпадение",
  mediumMatch: "Среднее совпадение",
  lowMatch: "Низкое совпадение",
  matchedOn: "Совпало по",
  lastComputed: "Последний расчёт",
  viewEntity: "Просмотр сущности",
  batchScore: "Групповая оценка",
  allTypes: "Все типы",
  matchError: "Ошибка поиска совпадений",
} as const;
export default matching;
